export default "/kiban/_next/static/images/taiwan-d96ed2a3881c43fe293aa7fcd17837b6.png";